export default __webpack_public_path__ + "static/media/icon-washer.b44ef75d.svg";